module.exports = __webpack_public_path__ + "static/WV-ca749b7c57731d7808e1613755f49332.svg";